import ProcessFlowStepElementConditionalRuleSet from "~/models/processFlows/processFlowStepElementConditionalRuleSet";

export default class FindCountStepConditionalRuleSet extends ProcessFlowStepElementConditionalRuleSet {
  afterDestroy() {
    super.afterDestroy();
    this.parent.createDefaultRuleSet();
  }
}